<template>
  <panel
    :on-hide="onHide"
    :store="store"
    title="Share"
  >
    <template slot="footer">
      <a
        :href="`${store.state.episode.episode_url}?share=true`"
        class="share-tools"
        target="simplecast-share"
        title="More Sharing Options"
        @click="store.sendShareSubscribeEvent('share', ' CLICK', 'share')"
      >More Options <icon-open /></a>

      <a
        v-if="mp3Url"
        :href="mp3Url"
        class="share-mp3"
        target="blank"
        title="Download MP3"
        @click="store.sendShareSubscribeEvent('share', 'DOWNLOAD', 'mp3')"
      ><span>Download&nbsp;</span>MP3 <icon-download /></a>
    </template>

    <div class="share-links">
      <div :class="['share-url', {copied: urlCopied}]">
        <div class="focusable">
          <input
            :value="episodeUrl"
            title="Episode URL"
            type="text"
            class="share-url_input"
            readonly
          >
        </div>
        <button
          v-clipboard:copy="episodeUrl"
          v-clipboard:success="copied"
          aria-label="Copy Episode URL"
          class="share-url_button"
          @click="store.sendShareSubscribeEvent('share', 'COPY', 'url')"
        ><span>Copy Link</span> <icon-copy /></button>
      </div>
      <ul class="social-links">
        <li class="twitter">
          <a
            :href="twitterUrl"
            title="Share on Twitter"
            target="simplecast-share">
            <twitter />
          </a>
        </li>
        <li class="facebook">
          <a
            :href="facebookUrl"
            title="Share on Facebook"
            target="simplecast-share"
          >
            <facebook />
          </a>
        </li>
        <li class="linkedin">
          <a
            :href="linkedInUrl"
            title="Share on LinkedIn"
            target="simplecast-share"
          >
            <linkedin />
          </a>
        </li>
      </ul>
    </div>
  </panel>
</template>

<script>
import IconCopy from '../assets/svg/copy.svg'
import IconDownload from '../assets/svg/download.svg'
import IconOpen from '../assets/svg/open.svg'
import Twitter from '../assets/svg/twitter.svg'
import Facebook from '../assets/svg/facebook.svg'
import Linkedin from '../assets/svg/linkedIn.svg'
import Panel from './Panel'

export default {
  components: {
    IconCopy,
    IconDownload,
    IconOpen,
    Twitter,
    Facebook,
    Linkedin,
    Panel
  },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  data () {
    return {
      urlCopied: false
    }
  },
  computed: {
    podcast () { return this.store.state.podcast },
    episode () { return this.store.state.episode },
    mp3Url () {
      if (!this.podcast.allow_mp3_downloads) return false
      return this.store.state.episode.enclosure_url
    },
    episodeUrl () {
      return this.store.state.episode.custom_url && this.store.state.episode.custom_url !== '' ? this.store.state.episode.custom_url : this.store.state.episode.episode_url
    },
    facebookUrl () {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.episodeUrl)}`
    },
    linkedInUrl () {
      let title = `${this.podcast.title} - ${this.episode.title}`
      let summary = `Have you checked out ${this.podcast.title} yet? Listen here: ${this.episodeUrl}`

      return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(this.episodeUrl)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}&source=Simplecast`
    },
    twitterUrl () {
      let text = `Have you listened to ${this.podcast.title} yet? Check it out here: ${this.episodeUrl}`

      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`
    }
  },
  watch: {
    urlCopied (val) {
      if (val) setTimeout(() => { this.urlCopied = false }, 2000)
    }
  },
  methods: {
    onHide () {
      this.store.setShowShare(false)
    },
    copied () {
      this.urlCopied = true
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.share-links {
  display: flex;
  justify-content: space-between;
  .share-url {
    display: flex;
    margin-right: 40px;
    width: 70%;
    &_input, &_button {
      border-radius: 2px;
      border: solid 1px $black-trans-400;
    }
    &_input {
      background: $grey-100;
      width: 100%;
      box-sizing: border-box;
      margin: 0;
      padding: 0 8px;
      @include font-s();
      height: 34px;
    }
    .focusable {
      flex-grow: 1;
       margin: 0 8px 0 0;
    }
    &_button {
      width: 36px;
      height: 36px;
      display: inline-block;
      justify-content: center;
      background: transparent;
      cursor: pointer;
      text-decoration: none;
      color: $black-trans-800;
      text-transform: uppercase;
      @include font-m-mono();
      font-size: 12px;
      letter-spacing: 0.6px;
      display: flex;
      align-items: center;
      span {
        display: none;
      }
      &:hover {
        opacity: .7;
      }
    }
    * {
      transition: background .2s ease-in-out;
    }
    &.copied
     {
      .share-url {
        &_input, &_button {
          &,
          &:active,
          &:hover {
            background: $green-100;
            color: $black-trans-800;
          }
          svg {
            fill: $black-trans-800;
            color: $black-trans-800;
          }
        }
      }
    }
  }
}

.social-links {
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
  justify-content: space-between;
  align-items: center;
  li {
    margin-left: 19px;
    &:first-child {
      margin-left: 0;
    }
  }
  .linkedin {
    margin-left: 21px;
    svg {
      margin-top: -1px;
    }
  }
  .twitter {
    svg {
      margin-top: 1px;
    }
  }
}

.share-tools, .share-mp3 {
  display: inline-flex;
  text-decoration: none;
  @include font-s();
  letter-spacing: 0.6px;
  text-transform: uppercase;
  align-items: center;
  svg {
    order: -1;
    margin-right: 8px;
  }
}
.share-mp3 {
  margin-left: 42px;
}

.panel-small {
  .share-mp3, .share-tools{
    span {
      display: none;
    }
  }
  .share-url {
    margin: 0;
    width: auto;
    &_input {
      display: none;
    }
    &_button {
      width: auto;
      display: inline-flex;
      span {
        display: inline-block;
      }
      svg {
        margin-right: 8px;
        order: -1;
      }
    }
  }
}

.panel-small {
  .share-url {
    margin: 0;
    width: auto;
    &_input {
      display: none;
    }
    &_button {
      width: auto;
      display: inline-flex;
      span {
        display: inline-block;
      }
      svg {
        margin-right: 8px;
        order: -1;
      }
    }
  }
}

.panel-smallest {
  .share-mp3{
    margin-left: 24px;
  }
  .social-links {
    li {
      margin-left: 16px;
    }
  }
}

.dark .share-links {
  .share-url_button,
  .share-url_input  {
    border-color: $white-trans-400;
  }
  .share-url_button {
    color: $white-trans-800;
  }
}
</style>
